import type { ConnectedPosition } from '@angular/cdk/overlay';

/** The plate edge a caret sits on, facing its anchor. */
export type CaretEdge = 'top' | 'bottom' | 'left' | 'right';

/**
 * Caret edge for the place the overlay strategy picked. A side place (anchor and plate meet edge to edge
 * on the X axis) puts the caret on the plate's near side edge; any other place puts it on the top edge
 * when the plate hangs below the anchor, the bottom edge when above — so a flip swaps caret and plate together.
 */
export function caretEdge({ originX, overlayX, overlayY }: ConnectedPosition): CaretEdge {
  const beside = originX !== overlayX && originX !== 'center' && overlayX !== 'center';
  if (beside) return overlayX === 'start' ? 'left' : 'right';

  return overlayY === 'top' ? 'top' : 'bottom';
}
